export const translates: Record<string, string> = {
  'auth.login.loginText': 'Iniciar Sesión',
  'auth.login.title': 'Bienvenido de nuevo',
  'auth.login.contactUs': 'Contacta con nosotros:',
  'cash-register.open': 'Ingrese dinero inicial',
  'cash-register.create': 'Crea una nueva caja',
  indicatorsReport: 'Indicadores cobrados',
  indicators: 'Indicadores',
  createAt: 'Fecha de creacion',
  supplies: 'Insumos',
  productIndicatorCreatedWarning: 'El producto no tiene indicador creado',
  productDontHaveRecipe: 'El producto no tiene receta',
  discountMoment: 'Descuentos hasta el momento',
  isGlobal: 'Global',
  restore: 'Restaurar',
  photo: 'Foto',
  promotion: 'Promocion',
  document: 'Documento',
  title: 'Titulo',
  EditInventory: 'Ajustar',
  getDisabled: 'Deshabilitar',
  priceHours: 'Precio por horas',
  useStock: 'Inventariar',
  groupIngredients: 'Grupo de ingredientes',
  groupRawMaterial: 'Grupo de insumos',
  presition: 'Presicion',
  indicator: 'Indicador',
  settings: 'Configuracion',
  codeFacture: 'Codigo de factura',
  logo: 'Logo',
  timezone: 'Zona horaria',
  add_discount: 'Agregar descuento (Productos)',
  cash: 'Efectivo',
  nit: 'Nit',
  company: 'Empresa',
  branch: 'Sucursal',
  select: 'Seleccionar',
  address: 'Direccion',
  typeBusiness: 'Tipo de negocio',
  type: 'Tipo',
  creditCard: 'Datafono',
  transference: 'Transferencia',
  name: 'Nombre ',
  fullname: 'Nombre completo',
  quantity: 'Cantidad',
  description: 'Descripcion',
  price: 'Precio',
  quantity_discount: 'Cantidad a descontar',
  discount: 'Descuento',
  percentageDiscount: '%',
  groups: 'Grupos',
  total: 'Total',
  isBranch: 'Con Sucursal',
  status: 'Estado',
  paid: 'Pagado',
  re_open: 'Reabierto',
  shopping: 'Compras',
  id: 'Id',
  open_orders: 'Ordenes abiertas',
  closed_orders: 'Ordenes cerradas',
  history: 'Historial',
  history_transactions: 'Historial de transacciones',
  history_payment_method: 'Historial cambios de metodo de pago',
  history_re_open: 'Historial ordenes reabiertas',
  history_tips: 'Historial cambio de propinas',
  open: 'Abierto',
  closed: 'Cerrado',
  done: 'Entregado',
  created: 'Creado',
  cooking: 'Cocinando',
  addOrderProduct: 'Agregar producto a orden',
  add_product: 'Agregar producto',
  divider_order: 'Dividir orden',
  print_commander: 'Imprimir Comanda',
  edit_order: 'Editar orden',
  pay: 'Pagar',
  edit: 'Editar ',
  tip: 'Propina',
  tips: 'Propinas',
  tipsWaiter: 'Propinas personal',
  tipsCompany: 'Propinas empresa',
  IPO: 'IPO',
  DT: 'DT',
  discount_value: 'Descuentos',
  list: 'Lista ',
  view: 'Detalle ',
  new: 'Nuevo ',
  newtwo: 'Nueva ',
  newCompany: 'Nueva empresa',
  newBranch: 'Nueva Sucursal',
  isOrder: 'Indicador de ordenes',
  isTips: 'Indicador de propinas',
  isProduct: 'Indicador de productos',
  isFactureBase: 'Indicador de facturas',
  priority: 'Prioridad',
  order: 'Orden ',
  orders: 'Ordenes ',
  user: 'Usuario ',
  users: 'Usuarios ',
  product: 'Producto ',
  products: 'Productos ',
  category: 'Categoria ',
  categories: 'Categorias ',
  ingredient: 'Insumos ',
  ingredients: 'Insumos ',
  raw: 'Insumo',
  material: 'Prima',
  providers: 'Proveedores ',
  recipes: 'Recetas ',
  reservation: 'Reservacion',
  reservations: 'Reservaciones ',
  monitoring: 'Monitor ',
  daily: 'Diario ',
  date: 'Fecha',
  startTime: 'Fecha de inicio ',
  openBy: 'Abierta por ',
  rowsPerPage: 'Filas por pagina',
  create: 'Crear ',
  calculatedAllPrice: 'Calcular todos los precios',
  save: 'Guardar ',
  cancel: 'Cancelar ',
  divider: 'Dividir',
  age: 'Edad ',
  box: 'Caja ',
  actual: 'Actual',
  turnClose: 'Cerrar turno',
  turnOpen: 'Abrir turno',
  startDate: 'Fecha inicial',
  endDate: 'Fecha final',
  delete: 'Eliminar',
  messageDelete: 'Esta seguro que desea eliminar',
  messageRestore: 'Esta seguro que desea Habilitarlo?',
  messageDisable: 'Esta seguro que desea Deshabilitarlo?',
  item: 'item',
  saveChanges: 'Guardar cambios',
  tipsMoment: 'Propinas hasta el momento',
  paymentMethod: 'Metodos de pago',
  amountProductByLines: 'Cantidades vendidas por marcas',
  moneyByLines: 'Ventas por marcas',
  amountProductByCategories: 'Cantidades vendidas por categorias',
  moneyByCategories: 'Ventas por categorias',
  listMood: 'Modo lista',
  gridMood: 'Modo grid',
  loading: 'Cargando',
  dividerCheckout: 'Dividir Cuenta',
  paymentTotalBefore: 'Total anterior',
  waiter: 'Mesero ',
  add: 'Agregar',
  addAmountToCancel: 'Agregar monto a cancelar',
  numberTransaction: 'Numero de transaccion',
  valueTransaction: 'Valor de transaccion',
  value: 'Valor',
  transaction: 'Transaccion',
  transactions: 'Transacciones',
  editValueToCancel: 'Editar valor a cancelar',
  addValueToCancel: 'Agregar valor a cancelar',
  'by date': 'Por fecha',
  'ingredient-price': 'Precio de insumos',
  'cash-register': 'Caja registradora',
  'canceled-products': 'Productos cancelados',
  'by cash register': 'Por caja registradora',
  'sell products by lines': 'Productos vendidos por linea',

  retreat: 'Retiro',
  withdraw: 'Realizar retiro',
  deposit: 'Deposito',
  makeDeposit: 'Realizar deposito',
  cashRegisterClosed: 'Caja cerrada, no es posible realizar ordenes',
  dashboard: 'Cuadro de mandos',
  search: 'Buscar',
  change: 'Cambiar',
  notFoundCashRegister: 'No se encontraron cajas registradoras',
  notFoundOpenCashRegister: 'No hay una caja abierta',
  alreadyOpenCashRegister: 'Ya hay una caja abierta',
  invalidCredentials: 'Credenciales invalidas',
  userNotFound: 'Usuario no encontrado',
  userDisabled: 'Usuario deshabilitado',
  emailAlreadyExists: 'El correo ya esta en uso',
  phoneAlreadyExists: 'El telefono ya esta en uso',
  invalidPhone: 'Telefono invalido',
  invalidEmail: 'Correo invalido',
  invalidPassword: 'Contraseña invalida',
  invalidUsername: 'Nombre de usuario invalido',
  invalidName: 'Nombre invalido',
  invalidLastname: 'Apellido invalido',
  authInvalidCredentials: 'Credenciales invalidas',
  authUserDisabled: 'Usuario deshabilitado',
  authWrongPassword: 'Usuario o Contraseña invalidos',
  authUserNotFound: 'Usuario no existe',
  authEmailAlreadyExists: 'Correo ya Existe',
  tableNameExist: 'Nombre de mesa esta en uso',
  notHaveIngredientsToAllProducts: 'Un producto ha superado la cantidad disponible',
  errorQuantity: 'Cantidad incorrecta',
  orderInProgress: 'Los productos a eliminar ya estan cocinando o terminados',
  invalidPay: 'Montos ingresados no coinciden con el total de la orden ',
  errorNoPermissions: 'No posees permisos para realizar esta accion',
  notEnoughCash: 'No hay dinero suficiente',
  differenceCashCloseRegister: 'Totales iguales, pero con diferencia en los metodos',
  email: 'Correo',
  telephone: 'Telefono',
  phone: 'Celular',
  password: 'Contraseña',
  rol: 'Cargo',
  indicativeNumber: 'Numero de indicativo',
  createdAt: 'Fecha de creacion',
  closedAt: 'Fecha de finalizacion',
  printInvoice: 'Imprimir factura',
  changeTipValuesEntered: 'Cambiar valores de propina ingresados',
  changeEnteredPaymentValues: 'Cambiar valores de pago ingresados',
  reOpenOrder: 'Reabrir Orden',
  detail: 'Detalle',
  table: 'Mesa',
  remove: 'Remover',
  orderItem: 'Item de la orden',
  addSection: 'Agregar seccion',
  checkout: 'Cuenta',
  orderDiscount: 'Descuento a orden',
  client: 'Cliente',
  accountInformation: 'Informacion de cuenta',
  quantityProductsSell: 'Cantidad de productos vendidos',
  moneyByProduct: 'Dinero de productos vendidos',
  line: 'Linea',
  lines: 'Lineas',
  percentage: 'Porcentaje',
  sellLetter: 'Precio carta',
  sellPrice: 'Precio venta',
  subTotal: 'Subtotal',
  active: 'Activo',
  inactive: 'Inactivo',
  disable: 'Deshabilitado',
  updateProductPrices: 'Actulizar precios de productos',
  messageUpdateProducts:
    'Esta seguro de actualizar todo los precios de los productos, actualmente solo se calcula a partir de el precio de venta que tengan los productos.',
  messageChangeStatusProduct: 'Esta seguro que desea cambiar?',
  resale: 'Reventa',
  available: 'Disponible',
  isBowl: 'Tipo bowl',
  color: 'Color',
  measure: 'Medida',
  inventory: 'Inventario',
  priceByMinimalPrice: 'Precio por unidad',
  lastPurchase: 'Ultima compra',
  unit: 'Unidad',
  bookingDate: 'Fecha de reserva',
  time: 'Hora',
  assistants: 'N° de personas',
  plan: 'Plan',
  plans: 'Planes',
  reservationData: 'Datos de la reserva',
  bookingData: 'Datos del que reserva',
  observation: 'Observaciones',
  writeWhatsapp: 'Escribir al whatsapp',
  base: 'Monto base',
  initialCash: 'Dinero inicial',
  moneyClose: 'Dinero al cierre',
  finalCash: 'Dinero final',
  atmOpen: 'Cajero que abrio',
  atmClose: 'Cajero que cerro',
  diference: 'Diferencia',
  mismatch: 'Descuadre',
  inconsistent: 'Inconsistente',
  consistent: 'Consistente',
  specificDifferences: 'Diferencias especificas',
  dataEnteredClosing: 'Datos Ingresados al cierre',
  changeTips: 'Cambio de propinas',
  ordersReopen: 'Ordenes reabiertas',
  canceledProducts: 'Productos Cancelados',
  noData: 'No hay datos',
  pricePLan: 'Ingrese el precio del plan',
  image: 'Imagen',
  namePlan: 'Ingrese nombre del plan',
  descriptionPlan: 'Ingrese una descripcion del plan',
  urlImage: 'Ingrese url de la imagen',
  dataPlan: 'Datos del plan',
  completeProduct: 'Completar producto',
  reopenCategory: 'Abrir categoria',
  update: 'Actualizar',
  turns: 'Turnos',
  responsible: 'Responsable',
  register: 'Registro',
  cost: 'Costo',
  tables: 'Mesas',
  new_table: 'Nueva Mesa',
  table_name: 'Nombre Mesa',
  state_table: 'Estado Mesa',
  available_table: 'DISPONIBLE',
  busy_table: 'OCUPADA',
  customers_table: 'Cantidad de Sillas',
  figure_table: 'Figura Mesa',
  triangle_table: 'Triangulo',
  circle_table: 'Circulo',
  rectangle_table: 'Rectangulo',
  square_table: 'Cuadro',
};

// export const translates: Record<string, string> = {
//   cash: 'Espèces',
//   creditCard: 'Carte de crédit',
//   transference: 'Virement',
//   name: 'Nom',
//   quantity: 'Quantité',
//   description: 'Description',
//   price: 'Prix',
//   quantity_discount: 'Quantité à réduire',
//   discount: 'Remise',
//   percentageDiscount: '%',
//   total: 'Total',
//   status: 'Statut',
//   paid: 'Payé',
//   re_open: 'Rouvrir',
//   id: 'Identifiant',
//   history_transactions: 'Historique des transactions',
//   history_payment_method: 'Historique des changements de mode de paiement',
//   history_re_open: 'Historique des commandes rouvertes',
//   history_tips: 'Historique des changements de pourboires',
//   closed: 'Fermé',
//   done: 'Livré',
//   created: 'Créé',
//   cooking: 'En préparation',
//   addOrderProduct: 'Ajouter un produit à la commande',
//   add_product: 'Ajouter un produit',
//   divider_order: 'Diviser la commande',
//   print_commander: 'Imprimer la commande',
//   edit_order: 'Modifier la commande',
//   pay: 'Payer',
//   edit: 'Modifier',
//   tip: 'pointe',
//   tips: 'conseils',
//   tipsWaiter: 'Pourboires serveur',
//   tipsCompany: "Pourboires de l'entreprise",
//   ICA: 'ICA',
//   DT: 'DT',
//   discount_value: 'Réductions',
//   list: 'Liste ',
//   view: 'Détails',
//   new: 'Nouveau',
//   order: 'Commande',
//   orders: 'Commandes',
//   company: 'Utilisateur',
//   users: 'Utilisateurs',
//   product: 'Produit',
//   products: 'Produits',
//   category: 'Catégorie',
//   categories: 'Catégories',
//   ingredient: 'Ingrédient',
//   ingredients: 'Ingrédients',
//   providers: 'Fournisseurs',
//   recipes: 'Recettes',
//   reservations: 'Réservations',
//   plans: 'Plans',
//   monitoring: 'Surveillance',
//   daily: 'Quotidien',
//   startTime: 'Heure de début',
//   openBy: 'Ouvert par',
//   rowsPerPage: 'Lignes par page',
//   create: 'Créer',
//   calculatedAllPrice: 'Calculer tous les prix',
//   save: 'Enregistrer',
//   cancel: 'Annuler',
//   divider: 'Diviser',
//   age: 'Âge',
//   box: 'Boîte',
//   actual: 'Actuel',
//   turnClose: 'Fermer le service',
//   turnOpen: 'Ouvrir le service',
//   startDate: 'Date de début',
//   endDate: 'Date de fin',
//   delete: 'Supprimer',
//   messageDelete: 'Êtes-vous sûr de vouloir supprimer ?',
//   item: 'élément',
//   saveChanges: 'Enregistrer les modifications',
//   tipsMoment: "Pourboires jusqu'à présent",
//   paymentMethod: 'Méthodes de paiement',
//   amountProductByLines: 'Quantité vendue par marques',
//   moneyByLines: 'Ventes par marques',
//   listMood: 'Mode liste',
//   gridMood: 'Mode grille',
//   loading: 'Chargement',
//   dividerCheckout: 'Diviser la note',
//   paymentTotalBefore: 'Total précédent',
//   waiter: 'Serveur',
//   add: 'Ajouter',
//   addAmountToCancel: 'Ajouter un montant à annuler',
//   numberTransaction: 'Numéro de transaction',
//   valueTransaction: 'Valeur de la transaction',
//   value: 'Valeur',
//   transaction: 'Transaction',
//   editValueToCancel: 'Modifier la valeur à annuler',
//   addValueToCancel: 'Ajouter une valeur à annuler',
//   'by date': 'Par date',
//   'ingredient-price': 'Prix des ingrédients',
//   'cash-register': 'Caisse enregistreuse',
//   'canceled-products': 'Produits annulés',
//   withdraw: 'Effectuer un retrait',
//   deposit: 'Effectuer un dépôt',
//   cashRegisterClosed: 'Boîte fermée, aucune commande possible',
//   dashboard: 'Tableau de bord',
//   search: 'recherche',
//   change: 'Changer',
//   notFoundOpenCashRegister: "Il n'y a pas de boîte ouverte",
//   alreadyOpenCashRegister: 'Il y a déjà une boîte ouverte',
//   invalidCredentials: 'Identifiants invalides',
//   userNotFound: 'Utilisateur non trouvé',
//   userDisabled: 'Utilisateur désactivé',
//   emailAlreadyExists: "L'adresse e-mail est déjà utilisée",
//   phoneAlreadyExists: 'Le numéro de téléphone est déjà utilisé',
//   invalidPhone: 'Numéro de téléphone invalide',
//   invalidEmail: 'Adresse e-mail invalide',
//   invalidPassword: 'Mot de passe invalide',
//   invalidUsername: "Nom d'utilisateur invalide",
//   invalidName: 'Nom invalide',
//   invalidLastname: 'Nom de famille invalide',
//   authInvalidCredentials: 'Identifiants invalides',
//   authUserDisabled: 'Utilisateur désactivé',
//   authWrongPassword: 'Utilisateur ou mot de passe incorrect',
//   authUserNotFound: 'Utilisateur non trouvé',
//   authEmailAlreadyExists: "L'adresse e-mail existe déjà",
//   tableNameExist: 'Le nom de la table est déjà utilisé',
//   notHaveIngredientsToAllProducts: 'Un produit a dépassé la quantité disponible',
//   errorQuantity: 'Quantité incorrecte',
//   orderInProgress: 'Les produits à supprimer sont déjà en préparation ou terminés',
//   invalidPay: 'Les montants saisis ne correspondent pas au total de la commande',
//   errorNoPermissions: "Vous n'avez pas les autorisations nécessaires pour effectuer cette action",
//   notEnoughCash: "Pas assez d'argent",
//   differenceCashCloseRegister:
//     'Totals identiques, mais avec une différence dans les méthodes de paiement',
//   email: 'Courriel',
//   telephone: 'Téléphone',
//   phone: 'Mobile',
//   password: 'Mot de passe',
//   rol: 'Charge',
//   indicativeNumber: 'Nombre indicatif',
//   createdAt: 'Date de création',
//   printInvoice: 'Imprimer la facture',
//   changeTipValuesEntered: 'Modifier les valeurs de pourboire saisies',
// };
